import React, { useState } from "react";
import { motion } from "framer-motion";
import Top from "../../components/Top";
import emailjs from "@emailjs/browser";
import { Toaster, toast } from "react-hot-toast";
import LayoutFr from "../../components/LayoutFr";
import TrainsFr from "./TrainsFr";

function TrainingFr() {
	const [email, setEmail] = useState("");

	const handleSubmit = (e) => {
		e.preventDefault();
		//keys and services
		const templateId = "template_k06u98r";
		const publicKey = "vRKpOxPaAllPvKD00";
		const serviceId = "service_1icj9w8";

		//create new object

		const templateParams = {
			to_name: "Africa55Durable Email News request",
			from_email: email,
		};

		//send theEmail
		emailjs
			.send(serviceId, templateId, templateParams, publicKey)
			.then((response) => {
				console.log("Message successfully sent", response);
				setEmail("");
			})
			.catch((error) => {
				console.error("Error sending", error);
			});

		//////////
		const refreshToast = toast.loading(
			"Your message has been sent. We will shortly contact you"
		);
		toast.success("Your message has been sent. We will shortly contact you", {
			id: refreshToast,
			duration: 7000,
		});

		/// navigate to
	};
	return (
		<LayoutFr>
			<Top />
			<>
				<motion.div className="flex flex-1 justify-center mt-6 ">
					<p className=" border-b-8 border-emerald-800 pb-2 text-2xl w-fit text-orange-500">
						les futures conférences
					</p>
				</motion.div>
				<p className=" flex flex-1 text-xl italic text-black font-extralight justify-center mt-5 text-center ">
				Nous vous tenons au courant des mouvements quotidiens et des tendances dans le monde du développement alternatif.
				</p>
				<div className="sm:flex w-full overflow-x-auto  overflow-hidden  scrollbar-hide ">
					<TrainsFr />
				</div>

				<div className="bg-emerald-300 sm:flex justify-center hidden items-center space-x-6 rounded-md py-4 mt-6 mx-40">
					<p className="italic text-lg">
						{" "}
						Votre Email pour rester informer
					</p>

					<from className="text-lg">
						<div className="flex items-center space-x-4">
							<input
								type="text"
								placeholder="Your Email please"
								className="bg-white px-2 outline-none"
							/>
							<p className=" bg-teal-600 hover:bg-teal-400  px-4 font-light text-white hover:text-black rounded-full cursor-pointer">
								Envoyer 
							</p>
						</div>
					</from>
				</div>


				<div className="bg-emerald-300 flex flex-col sm:hidden items-center space-y-6 rounded-md py-4 mt-6 px-6">
					<p className="italic text-lg">
						{" "}
						Votre Email pour rester informer
					</p>

					<from className="text-lg">
						<div className="flex items-center space-x-4">
							<input
								type="text"
								placeholder="Your Email please"
								className="bg-white px-2 outline-none"
							/>
							<p className=" bg-teal-600 hover:bg-teal-400  px-4 font-light text-white hover:text-black rounded-full cursor-pointer">
								Envoyer
							</p>
						</div>
					</from>
				</div>
			</>
		</LayoutFr>
	);
}

export default TrainingFr;
